module.exports = __webpack_public_path__ + "static/media/profile.2a574801.webp";